import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface MatchResults {
  matches: MatchResult[];
}

export interface MatchResult {
  date: string;
  player1: number;
  player2: number;
}

export enum API_HEADER {
  HEADER_NAME = 'X-Pfiffige-Ziffern',
  HEADER_GET_PRICE = 'Get-Price',
  HEADER_GET_STATS = 'Get-Stats',
  HEADER_POST_PRICE = 'Post-Price',
  HEADER_POST_RESULTS = 'Post-Results',
}

@Injectable({
  providedIn: 'root',
})
export class StatsService {
  // TODO: Find a better way for local API (fakebackend)
  private api = 'https://pz.steven-birr.de/api/'; // Heads up! PR API

  constructor(private httpClient: HttpClient) {}

  public getStats(): Observable<any> {
    return this.httpClient.get(this.api, {
      headers: {
        [API_HEADER.HEADER_NAME]: API_HEADER.HEADER_GET_STATS, // Custom HTTP header for "security" :-D
      },
    });
  }

  public setStats(matchResults: MatchResults): Observable<any> {
    return this.httpClient.post(this.api, JSON.stringify(matchResults), {
      headers: {
        [API_HEADER.HEADER_NAME]: API_HEADER.HEADER_POST_RESULTS, // Custom HTTP header for "security" :-D
      },
    });
  }

  public getPrice(): Observable<any> {
    return this.httpClient.get(this.api, {
      headers: {
        [API_HEADER.HEADER_NAME]: API_HEADER.HEADER_GET_PRICE, // Custom HTTP header for "security" :-D
      },
    });
  }

  public resetPrice(): Observable<any> {
    return this.httpClient.post(
      this.api,
      {},
      {
        headers: {
          [API_HEADER.HEADER_NAME]: API_HEADER.HEADER_POST_PRICE, // Custom HTTP header for "security" :-D
        },
      }
    );
  }
}
